// 🔧 API base instellen (werkt lokaal en in productie)
const API_BASE = window.location.hostname === "localhost"
  ? "http://localhost:4000"
  : "";

// Helper voor admin dashboard generatie en functionaliteit
function bindPasswordGenerator(modal, {
  cancelSelector,
  passwordSelector,
  generateBtnSelector,
  messageSelector
}) {
  // ❌ Annuleren
  const cancelBtn = modal.querySelector(cancelSelector);
  if (cancelBtn) {
    cancelBtn.onclick = () => modal.remove();
  }

  // 🔑 Generator
  const genBtn = modal.querySelector(generateBtnSelector);
  const pwInput = modal.querySelector(passwordSelector);
  const msg = modal.querySelector(messageSelector);

  if (genBtn && pwInput) {
    genBtn.onclick = () => {
      const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*()_+-=";
      let password = "";
      for (let i = 0; i < 12; i++) {
        password += chars[Math.floor(Math.random() * chars.length)];
      }

      pwInput.value = password;

      if (msg) {
        msg.classList.remove("hidden");
        setTimeout(() => msg.classList.add("hidden"), 2000);
      }
    };
  }
}
function formatDate(dateString) {
  if (!dateString) return "—";
  return new Date(dateString).toLocaleString("nl-NL", {
    dateStyle: "short",
    timeStyle: "short"
  });
}


// 📄 HTML genereren
export function adminDashboard() {
  return `
    <div id="admin-dashboard" class="p-6 space-y-6 min-h-screen bg-gray-50">
      <div class="flex items-center justify-between mb-6">
        <h1 class="text-3xl font-bold">Admin Dashboard</h1>
        <button id="admin-logout" class="bg-red-600 text-white px-4 py-2 rounded hover:bg-red-700">
          Uitloggen
        </button>
      </div>

      <div class="bg-white shadow rounded-2xl p-6 border border-gray-200">
        <div class="flex items-center justify-between mb-4">
          <h2 class="text-xl font-semibold">Gebruikersbeheer</h2>
          <button id="add-user" class="bg-green-600 text-white px-3 py-2 rounded hover:bg-green-700">
            ➕ Nieuwe gebruiker
          </button>
        </div>

        <div class="overflow-x-auto">
          <table class="min-w-full text-left border-collapse">
            <thead class="bg-gray-100 text-gray-600">
              <tr>
                <th class="py-2 px-4 border-b">Naam</th>
                <th class="py-2 px-4 border-b">Email</th>
                <th class="py-2 px-4 border-b">Rol</th>
                <th class="py-2 px-4 border-b">Aangemaakt</th>
                <th class="py-2 px-4 border-b">Bijgewerkt</th>
                <th class="py-2 px-4 border-b text-center">Acties</th>
              </tr>
            </thead>
            <tbody id="user-table">
              <tr><td colspan="4" class="py-3 text-center">Laden...</td></tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  `;
}

// ⚙️ Data ophalen en DOM vullen
export async function initAdminDashboard() {
  const auth = await fetch(`${API_BASE}/api/checkAdminAuth`, { credentials: "include" });
  if (auth.status === 401) {
    window.location.href = "/register/";
    return;
  }

  const table = document.getElementById("user-table");
  const logoutBtn = document.getElementById("admin-logout");
  const addUserBtn = document.getElementById("add-user");

  if (!table || !logoutBtn || !addUserBtn) return;

  logoutBtn.onclick = async () => {
    await fetch(`${API_BASE}/api/logoutAdmin`, { method: "POST", credentials: "include" });
    window.location.href = "/portaal/adminlogin";
  };

  // USERS OPHALEN
  const res = await fetch(`${API_BASE}/api/adminDashboard`, { credentials: "include" });
  const data = await res.json();

  table.innerHTML = "";
  data.users.forEach(user => {
    const tr = document.createElement("tr");
tr.innerHTML = `
  <td class="py-2 px-4 border-b">${user.name}</td>
  <td class="py-2 px-4 border-b">${user.email}</td>
  <td class="py-2 px-4 border-b">${user.role}</td>
  <td class="py-2 px-4 border-b text-sm text-gray-600">
    ${formatDate(user.createdAt)}
  </td>
  <td class="py-2 px-4 border-b text-sm text-gray-600">
    ${formatDate(user.updatedAt)}
  </td>
  <td class="py-2 px-4 border-b text-center space-x-2">
    <button data-action="update" data-id="${user.id}" class="bg-blue-600 text-white px-3 py-1 rounded">Bewerk</button>
    <button data-action="block" data-id="${user.id}" class="bg-yellow-600 text-white px-3 py-1 rounded">
      ${user.isBlock ? "Deblokkeer" : "Blokkeer"}
    </button>
    <button data-action="delete" data-id="${user.id}" class="bg-red-600 text-white px-3 py-1 rounded">Verwijder</button>
  </td>
`;

    table.appendChild(tr);
  });

  // ACTIES
  table.onclick = async (e) => {
    const btn = e.target.closest("button[data-action]");
    if (!btn) return;

    const { action, id } = btn.dataset;

if (action === "update") {
  const user = data.users.find(u => u.id == id);
  if (!user) return;

  openUpdateModal(user);
  return;
}


    if (action === "block") {
      if (!confirm("Weet je zeker?")) return;
      await fetch(`${API_BASE}/api/block-user/${id}`, { method: "POST", credentials: "include" });
      initAdminDashboard();
      return;
    }

    if (action === "delete") {
      if (!confirm("⚠️ Weet je zeker?")) return;
      await fetch(`${API_BASE}/api/delete-user`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ id })
      });
      initAdminDashboard();
    }
  };

  // ADD USER
  addUserBtn.onclick = () => openAddUserModal();
}

// ➕ ADD USER MODAL
function openAddUserModal() {
  const modal = document.createElement("div");
  modal.innerHTML = `
<div class="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
  <div class="bg-white rounded-2xl shadow-xl w-full max-w-md p-6 relative">
    <!-- Sluiten / annuleren -->
    <button
      type="button"
      id="close-add-modal"
      class="absolute top-3 right-3 text-gray-400 hover:text-gray-600 text-2xl"
      aria-label="Sluiten"
    >
      &times;
    </button>

    <h3 class="text-xl font-semibold mb-6 text-gray-800">
      Nieuwe gebruiker toevoegen
    </h3>

    <form id="add-user-form" class="space-y-4">
      <!-- Naam -->
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">Naam</label>
        <input
          type="text"
          name="name"
          required
          class="w-full rounded-lg border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
          placeholder="Volledige naam"
        />
      </div>

      <!-- Email -->
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">Email</label>
        <input
          type="email"
          name="email"
          required
          class="w-full rounded-lg border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
          placeholder="email@voorbeeld.nl"
        />
      </div>

      <!-- Wachtwoord + generator -->
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">
          Wachtwoord
        </label>
        <div class="flex gap-2">
          <input
            type="text"
            name="password"
            id="add-user-password"
            required
            class="flex-1 rounded-lg border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="Automatisch of handmatig"
          />
          <button
            type="button"
            id="generate-password"
            class="px-3 py-2 rounded-lg bg-gray-200 hover:bg-gray-300 text-sm"
            title="Genereer wachtwoord"
          >
            🔑
          </button>
        </div>
        <p
          id="password-generated-msg"
          class="text-xs text-green-600 mt-1 hidden"
        >
          Wachtwoord gegenereerd
        </p>
      </div>

      <!-- Rol -->
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">Rol</label>
        <select
          name="role"
          required
          class="w-full rounded-lg border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
        >
          <option value="user">Adviseur</option>
          <option value="admin">Partner</option>
        </select>
      </div>

      <!-- Actieknoppen -->
      <div class="flex justify-end gap-3 pt-4">
        <button
          type="submit"
          class="px-4 py-2 rounded-lg bg-green-600 hover:bg-green-700 text-white font-medium"
        >
          Toevoegen
        </button>
      </div>
    </form>
  </div>
</div>

  `;
  document.body.appendChild(modal);
bindPasswordGenerator(modal, {
  cancelSelector: "#close-add-modal",
  passwordSelector: "#add-user-password",
  generateBtnSelector: "#generate-password",
  messageSelector: "#password-generated-msg"
});

  modal.querySelector("form").onsubmit = async (e) => {
    e.preventDefault();
    const f = e.target;
    await fetch(`${API_BASE}/api/add-user`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify({
        name: f.name.value,
        email: f.email.value,
        password: f.password.value,
        role: f.role.value
      })
    });
    modal.remove();
    initAdminDashboard();
  };
}

// ✏️ UPDATE USER MODAL
function openUpdateModal(user) {
  const modal = document.createElement("div");
  modal.innerHTML = `
<div class="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
  <div class="bg-white w-full max-w-md rounded-2xl shadow-xl p-6 relative">
    <!-- Sluiten -->
    <button
      type="button"
      id="cancel-update-user"
      class="absolute top-3 right-3 text-gray-400 hover:text-gray-600 text-xl"
    >
      &times;
    </button>

    <h3 class="text-lg font-semibold mb-4">Gebruiker bijwerken</h3>

    <form id="update-user-form" class="space-y-4">
      <div>
        <label class="block text-sm font-medium mb-1">Naam</label>
        <input
          name="name"
          required
          class="w-full border rounded-lg px-3 py-2 focus:outline-none focus:ring focus:ring-blue-200"
          placeholder="Naam"
        />
      </div>

      <div>
        <label class="block text-sm font-medium mb-1">Email</label>
        <input
          name="email"
          type="email"
          required
          class="w-full border rounded-lg px-3 py-2 focus:outline-none focus:ring focus:ring-blue-200"
          placeholder="Email"
        />
      </div>

      <div>
        <label class="block text-sm font-medium mb-1">Rol</label>
        <select
          name="role"
          class="w-full border rounded-lg px-3 py-2 focus:outline-none focus:ring focus:ring-blue-200"
        >
          <option value="user">Adviseur</option>
          <option value="admin">Partner</option>
        </select>
      </div>

      <div>
        <label class="block text-sm font-medium mb-1">Nieuw wachtwoord (optioneel)</label>
        <div class="flex gap-2">
          <input
            name="password"
            id="update-user-password"
            class="w-full border rounded-lg px-3 py-2 focus:outline-none focus:ring focus:ring-blue-200"
            placeholder="Nieuw wachtwoord"
          />
          <button
            type="button"
            id="generate-update-password"
            class="px-3 py-2 rounded-lg bg-gray-200 hover:bg-gray-300"
            title="Genereer wachtwoord"
          >
            🔑
          </button>
        </div>
        <p
          id="update-password-generated-msg"
          class="text-xs text-green-600 mt-1 hidden"
        >
          Wachtwoord gegenereerd!
        </p>
      </div>

      <div class="flex gap-3 pt-2">
        <button
          type="submit"
          class="w-1/2 px-4 py-2 rounded-lg bg-blue-600 text-white hover:bg-blue-700"
        >
          Opslaan
        </button>
      </div>
    </form>
  </div>
</div>

  `;
document.body.appendChild(modal);

  modal.querySelector("[name='name']").value = user.name;
  modal.querySelector("[name='email']").value = user.email;
  modal.querySelector("[name='role']").value = user.role;

  bindPasswordGenerator(modal, {
    cancelSelector: "#cancel-update-user",
    passwordSelector: "#update-user-password",
    generateBtnSelector: "#generate-update-password",
    messageSelector: "#update-password-generated-msg"
  });

modal.querySelector("form").onsubmit = async (e) => {
  e.preventDefault();
  const f = e.target;

  // 1️⃣ user opslaan
  const userRes = await fetch(`${API_BASE}/api/update-user`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify({
      id: user.id,
      name: f.name.value,
      email: f.email.value,
      role: f.role.value,
      password: f.password.value || undefined
    })
  });

  if (!userRes.ok) {
    console.error("User update failed");
    return;
  }

  // 2️⃣ company maken via uniek email
  const companyRes = await fetch(`${API_BASE}/api/admin/create-company`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify({
      email: f.email.value,
      name: f.name.value
    })
  });

  // als company al bestaat -> negeren
  if (!companyRes.ok) {
    const txt = await companyRes.text();
    if (!txt.includes("bestaat al")) {
      console.error("Company create failed:", txt);
      return;
    }
  }

  modal.remove();
  initAdminDashboard();
};
}